import { render, staticRenderFns } from "./importDetailCountry.vue?vue&type=template&id=1f230238&scoped=true&"
import script from "./importDetailCountry.vue?vue&type=script&lang=js&"
export * from "./importDetailCountry.vue?vue&type=script&lang=js&"
import style0 from "./importDetailCountry.vue?vue&type=style&index=0&id=1f230238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f230238",
  null
  
)

export default component.exports